const styles = theme => ({
  addMore: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    border: '1px dashed #919EAB52',
    borderRadius: '8px',
    gap: 8,
    padding: '4px 16px',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    backgroundColor: '#F8FAFC',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
  },
  headerSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '8px',
    },
  },
  buttonGroup: {
    display: 'flex',
    gap: '8px',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      gap: '8px',
      width: 'auto',
    },
  },

  attachmentItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  attachmentRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    padding: '12px 16px',
    borderRadius: '8px',
    alignItems: 'center',
    backgroundColor: '#F8FAFC',
  },
  fileName: {
    fontSize: '13px',
    fontWeight: 400,
    color: '#002E47',
    wordBreak: 'break-word',
  },
  flexGrow: {
    flexGrow: 1,
  },
  fileIcon: {
    fontSize: '16px',
    minWidth: '16px',
  },
  fileIconError: {
    color: '#d32f2f',
  },
  fileIconSuccess: {
    color: '#29D25D',
  },
  errorHint: {
    fontSize: '13px',
    color: '#d32f2f',
    marginLeft: '16px',
  },
  errorIcon: {
    fontSize: '16px',
    color: '#d32f2f',
  },
  uploadedText: {
    fontSize: '14px',
    fontWeight: 500,
  },
  rightSection: {
    width: '150px',
    minWidth: '150px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  progressArea: {
    flex: 1,
  },
  actionSlot: {
    width: '34px',
    minWidth: '34px',
    maxWidth: '34px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeIcon: {
    fontSize: '16px',
    color: '#ED4245',
    cursor: 'pointer',
  },
  tickIcon: {
    fontSize: '16px',
    color: '#29D25D',
  },
  iconDefault: {
    fontSize: '16px',
    color: '#919EAB',
    marginTop: 3,
  },
  iconHovered: {
    fontSize: '16px',
    color: '#015FFB',
    marginTop: 3,
  },
  textDefault: {
    fontSize: '14px',
    color: '#919EAB',
  },
  textHovered: {
    fontSize: '14px',
    color: '#015FFB',
  },
  progressTrack: {
    height: '6px',
    borderRadius: '999px',
    background: '#D9E7FF',
    overflow: 'hidden',
    flex: 1,
    opacity: 1,
    transform: 'scaleX(1)',
    transformOrigin: 'left center',
    transition: 'opacity 260ms ease, transform 260ms ease',
  },
  progressTrackExit: {
    opacity: 0,
    transform: 'scaleX(0.94)',
  },
  progressFill: {
    height: '100%',
    backgroundColor: '#015FFB',
    transition: 'width 700ms ease-out',
  },
  progressText: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#015FFB',
    lineHeight: 1,
  },
  progressTickReveal: {
    animation: '$tickReveal 260ms ease-out',
  },
  '@keyframes tickReveal': {
    '0%': {
      opacity: 0,
      transform: 'scale(0.82)',
    },
    '100%': {
      opacity: 1,
      transform: 'scale(1)',
    },
  },
  youtubeHint: {
    fontSize: '13px',
    color: '#425466',
    marginLeft: '16px',
  },
  documentFollowingContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginTop: '16px',
  },
})

export default styles
